import {formRequest} from '@/utils/request'

// 瀏覽紀錄
export function PostLog(data) {
  return formRequest({
    url: '/log',
    method: 'post',
    data
  })
}